<label class="input-label flex"
  >{{ label }}
  @if (isRequired) {
    <p class="text-err">*</p>
  }
</label>
<div class="relative">
  <div class="custom-input">
    <input class="shared-input" type="date" [formControl]="control" />
  </div>
</div>
@if (control.invalid && control.touched) {
  <p class="input-err">Required field.</p>
}
